module.exports = __webpack_public_path__ + "static/media/Products.ebe8b4ba.xlsx";